export default __webpack_public_path__ + "static/media/restaurants-large.02ea09c1.svg";